import React, { useEffect, useState } from 'react';
import './MoneyAnimation.css';

const MoneyAnimation = () => {
  const [showAnimation, setShowAnimation] = useState(true);

  useEffect(() => {
    // Animation runs for 3.5 seconds (continuous falling effect), then stop showing
    const timer = setTimeout(() => {
      setShowAnimation(false);
    }, 3500);

    return () => clearTimeout(timer);
  }, []);

  if (!showAnimation) return null;

  // Array of Indian currency amounts
  const amounts = ['1 lakh', '10 lakh', '1 crore', '10 crore', '50 crore', '50 lakhs'];

  // Array of money papers to fall like rain
  const moneyRain = Array.from({ length: 20 }, (_, i) => ({
    id: i,
    delay: (i * 0.1) % 3,
    duration: 1.2 + Math.random() * 0.8, // Random duration between 1.2-2 seconds (faster)
    offset: Math.random() * 100, // Random horizontal offset
    amount: amounts[i % amounts.length], // Cycle through amounts
  }));

  return (
    <div className="money-rain-container">
      {moneyRain.map((bill) => (
        <div
          key={bill.id}
          className="falling-bill"
          style={{
            '--delay': `${bill.delay}s`,
            '--duration': `${bill.duration}s`,
            '--offset': `${bill.offset}%`,
            '--left': `${Math.random() * 100}%`,
            animationDelay: `${bill.delay}s`,
            animationDuration: `${bill.duration}s`,
          }}
        >
          <div className="money-note">{bill.amount}</div>
        </div>
      ))}
    </div>
  );
};

export default MoneyAnimation;
